// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1YLWg","colMin":"styles_colMin__W_RJc","colCheckbox":"styles_colCheckbox__36eqH"};